@if (isModalOpen) {
  <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div
          class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
        >
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <div class="flex items-center">
                <h3 class="text-base font-semibold text-gray-700" id="modal-title">
                  <strong class="text-amazone-orange">Propagate</strong> changes to other releases
                </h3>
                <button
                  (click)="closeModal()"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center absolute right-6 cursor-pointer"
                  appAgentAction
                  agent="propagation-modal-close"
                  [businessObject]="businessObject"
                  [businessId]="entityId"
                  action="cancel"
                >
                  <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              <div class="my-4">
                <label class="text-gray-600" for="selection-nw">{{ callToActionDescription }}</label>
                @if (additionalInfoText) {
                  <p class="text-sm text-gray-500 mt-1">{{ additionalInfoText }}</p>
                }
                <div class="mt-2 space-y-2 max-h-[calc(100vh-25rem)] overflow-y-auto">
                  @for (option of propagationTargetOptions || []; track $index) {
                    <div
                      class="group flex items-center ps-4 bg-neutral-primary-soft border border-gray-300 rounded-md shadow-xs has-[:disabled]:text-gray-400"
                    >
                      <input
                        (change)="toggleSelection(option.id)"
                        id="{{ option.id }}"
                        type="checkbox"
                        value=""
                        [checked]="option.shouldCreate"
                        [readOnly]="option.readOnly"
                        [disabled]="option.readOnly"
                        name="bordered-checkbox"
                        class="w-4 h-4 border border-default-medium rounded-xs bg-neutral-secondary-medium focus:ring-2 focus:ring-brand-soft text-gray-800 group disabled:text-gray-400 disabled:cursor-not-allowed"
                      />
                      <label
                        for="{{ option.id }}"
                        class="select-none w-full py-4 ms-2 text-sm font-medium text-heading group-has-[:disabled]:text-gray-400 text-gray-800"
                      >
                        {{ option.number }}
                        @if (option.isNewItem) {
                          <span
                            class="ms-2 bg-amazone-green text-gray-100 text-xs font-medium px-2.5 py-0.5 rounded-sm"
                          >
                            new
                          </span>
                        }
                      </label>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-x-2">
            <button
              (click)="closeModal()"
              type="button"
              class="disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer inline-flex w-full justify-center rounded-md bg-gray-50 px-3 py-2 text-sm font-semibold text-amazone-orange ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
              appAgentAction
              agent="propagation-modal-skip"
              [businessObject]="businessObject"
              [businessId]="entityId"
              action="cancel"
            >
              Skip
            </button>
            <button
              (click)="execute()"
              type="button"
              class="disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer inline-flex w-full justify-center rounded-md bg-amazone-orange px-3 py-2 text-sm font-semibold text-gray-50 ring-1 shadow-xs hover:scale-105 transition ease-in-out sm:mt-0 sm:w-auto"
              appAgentAction
              agent="propagation-modal-execute"
              [businessObject]="businessObject"
              [businessId]="entityId"
              action="confirm"
            >
              {{ `${executionType} in selected branches` }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
